import { createApiActions } from '../../../helpers/actions';
import { UserProfile } from '../../../models';

export const fetchUserProfile = createApiActions<UserProfile>()(
  'fetch/userProfile',
  'fetch/userProfileSuccess',
  'fetch/userProfileError',
  () => ({})
);
